import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

export type AIModalType = 'customer-alert' | 'sales-opportunity' | 'policy' | 'appointment' | 'sales-report' | 'internal' | null

interface ModalState {
  isOpen: boolean
  type: AIModalType
  message: any
}

export const useAIMessageModal = () => {
  const navigate = useNavigate()
  const [modalState, setModalState] = useState<ModalState>({
    isOpen: false,
    type: null,
    message: null
  })

  const handleMessageClick = (message: any) => {
    let type: AIModalType = null

    // Kiểm tra type message trước
    if (message.type === 'internal') {
      type = 'internal'
    } else {
      // Kiểm tra theo từ khóa trong title
      if (message.title.includes('rời bỏ') || message.title.includes('trễ')) {
        type = 'customer-alert'
      } else if (message.title.includes('Cơ hội') || message.title.includes('chốt đơn')) {
        type = 'sales-opportunity'
      } else if (message.title.includes('Chính sách')) {
        type = 'policy'
      } else if (message.title.includes('quên hẹn')) {
        type = 'appointment'
      } else if (message.title.includes('Doanh thu')) {
        type = 'sales-report'
      }
    }

    if (type) {
      setModalState({
        isOpen: true,
        type,
        message
      })
    } else {
      // Nếu không có modal tương ứng thì chuyển hướng đến link
      if (message.link) {
        navigate(message.link)
      }
    }
  }

  const closeModal = () => {
    setModalState({
      isOpen: false,
      type: null,
      message: null
    })
  }

  return {
    modalState,
    handleMessageClick,
    closeModal
  }
} 